import { utils } from './utils';

/**
 * Formats a date string using the standard date formatter
 * Returns empty string if value is falsy or invalid date
 */
export const formatDate = (value: unknown): string => {
  if (!value) return '';
  const date = new Date(value as string);
  return Number.isNaN(date.getTime()) ? '' : utils.dateFormatter.format(date);
};

/**
 * Formats a number value using the standard number formatter
 * Returns empty string if value is null, undefined, or empty string
 */
export const formatNumber = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '';
  return utils.numberFormatter.format(Number(value));
};
